import { Bug, BugOff } from "lucide-react";
import { useLocalStorage } from "usehooks-ts";

import { DropdownMenuItem } from "@/components/ui/dropdown-menu";

export const ToggleTestingMode = () => {
  const [isTesting, setIsTesting] = useLocalStorage("testing-mode", false);
  return (
    <DropdownMenuItem onClick={() => setIsTesting(!isTesting)}>
      {isTesting ? (
        <BugOff size={12} className="mr-2" />
      ) : (
        <Bug size={12} className="mr-2" />
      )}
      {`${isTesting ? "Disable" : "Enable"} test panel`}
    </DropdownMenuItem>
  );
};
